import { Link } from 'react-router-dom'
import { LuRepeat } from 'react-icons/lu'
import { Button } from '@cannect/new-components/atoms'
import { subscriptionsCopy } from '../copy'

export const SubscriptionsEmpty = () => (
  <div className="flex w-full flex-col items-center gap-4 rounded-xl border border-solid border-neutral-100 bg-white px-4 py-10 text-center">
    <span
      className="flex h-14 w-14 items-center justify-center rounded-full bg-primary-50 text-primary-700"
      aria-hidden>
      <LuRepeat className="h-7 w-7" />
    </span>
    <h2 className="text-lg font-semibold text-neutral-800">{subscriptionsCopy.empty.title}</h2>
    <p className="max-w-md text-sm text-neutral-600">{subscriptionsCopy.empty.benefit}</p>
    <Button asChild size="md">
      <Link to="/produtos/1">{subscriptionsCopy.empty.cta}</Link>
    </Button>
  </div>
)
